/* eslint-disable @typescript-eslint/no-explicit-any */
import { Autocomplete, Divider, Grid, TextField } from "@mui/material";
import { ProductStockModel } from "../../Utils/Models";
import { Vocabulary } from "../../Utils/Vocabulary";
import ProductStockList from "./ProductStockList";
import React, { useEffect, useState } from "react";

type ProductStockProps = {
  allInventoriesForAutocomplete: any;
  inventories: ProductStockModel[];
  handleChangeInventories: (inventories: ProductStockModel[]) => void;
};

export default function ProductStock(props: ProductStockProps) {
  const {
    allInventoriesForAutocomplete,
    inventories,
    handleChangeInventories,
  } = props;
  //to reset the autocomplete after adding a new inventory
  const [workaround, setWorkaround] = useState(null);

  useEffect(() => {
    if (workaround) setWorkaround(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inventories]);
  /**
   *
   * @param index
   * @param inventory
   */
  function handleChangeOneInventory(index: number, inventory: any) {
    const newInventories = [...inventories];
    if (inventory) {
      newInventories[index] = inventory;
    } else {
      newInventories.splice(index, 1);
    }
    handleChangeInventories(newInventories);
  }
  return (
    <div style={{ marginTop: 20, width: "100%" }}>
      <Autocomplete
        freeSolo={false}
        disablePortal
        options={allInventoriesForAutocomplete}
        handleHomeEndKeys
        value={workaround}
        getOptionDisabled={(option) =>
          inventories &&
          !!inventories.find(
            (element: any) => element.inventory._id === option._id
          )
        }
        getOptionLabel={(option: any) =>
          `${option.name} - ${option.location?.name || ""}`
        }
        isOptionEqualToValue={(option, value) => option._id === value._id}
        renderInput={(params) => (
          <TextField {...params} label={Vocabulary.inventory} size="small" />
        )}
        onChange={(event, newValue: any) => {
          const newInventories = inventories ? [...inventories] : [];
          newInventories.push({
            inventory: newValue,
            quantity: 0,
            totalPrice: 0,
            pricePerQuantity: 0,
            percentageVAT: 0,
            isNew: true,
          });
          handleChangeInventories(newInventories);
          setWorkaround(newValue);
        }}
      />

      <Grid
        container
        spacing={2}
        style={{
          margin: "20px 0px",
          padding: 0,
          display: "flex",
          alignItems: "center",
        }}
      >
        <Grid item xs={12} sm={2} md={2} lg={2}>
          {Vocabulary.inventory}
        </Grid>
        <Grid item xs={12} sm={2} md={2} lg={2}>
          {Vocabulary.quantity}
        </Grid>
        <Grid item xs={12} sm={2.5} md={2.5} lg={2.5}>
          {Vocabulary.pricePerQuantity}
        </Grid>
        <Grid item xs={12} sm={2.5} md={2.5} lg={2.5}>
          {Vocabulary.totalPrice}
        </Grid>
        <Grid item xs={12} sm={2.5} md={2.5} lg={2.5}>
          {Vocabulary.vat}
        </Grid>
      </Grid>
      <Divider />
      {inventories &&
        inventories.map((inventory: ProductStockModel, index) => (
          <React.Fragment key={inventory?.inventory?._id}>
            <ProductStockList
              index={index}
              inventory={inventory}
              showDivider={index !== inventories.length - 1 ? true : false}
              handleChangeOneInventory={handleChangeOneInventory}
            />
          </React.Fragment>
        ))}
      {!inventories || inventories.length === 0 ? (
        <p style={{ textAlign: "center" }}>
          {Vocabulary.noInventoriesAssociated}
        </p>
      ) : null}
    </div>
  );
}
